import numeral from 'numeral';
import { getPercent } from './showDelta';

function showWithArrow(dataL) {
    const val = getPercent(dataL.at(-1), dataL[0]);
    const dir = val > 0 ? 'up' : 'down';

    const arrow = <i className="icon-arrow-right1"></i>;

    return (
        <div className={'table-delta-number-arrow ' + dir}>
            {arrow} {numeral(Math.abs(val)).format('0.0')}%
        </div>
    );
}

export function collectCell(data, dataL, format) {
    const delta = showWithArrow(dataL);

    return (
        <div>
            <div className={'table-delta-number '}>
                <strong>{numeral(data).format(format || '0.0a')}</strong>
                {delta}
            </div>
        </div>
    );
}
